// src/lib/assertions.ts
function isSwagger(schema) {
  return "swagger" in schema && schema.swagger !== void 0;
}
function isOpenAPI(schema) {
  return "openapi" in schema && schema.openapi !== void 0;
}
function isOpenAPI30(schema) {
  return "openapi" in schema && schema.openapi !== void 0 && schema.openapi.startsWith("3.0");
}
function isOpenAPI31(schema) {
  return "openapi" in schema && schema.openapi !== void 0 && schema.openapi.startsWith("3.1");
}
function isOpenAPI32(schema) {
  return "openapi" in schema && schema.openapi !== void 0 && schema.openapi.startsWith("3.2");
}

export {
  isSwagger,
  isOpenAPI,
  isOpenAPI30,
  isOpenAPI31,
  isOpenAPI32
};
//# sourceMappingURL=chunk-IYQ77VVR.js.map